import { createClient, type Session, type SupabaseClient } from '@supabase/supabase-js';
import { parseAuthCallback, sanitizeAuthCallbackUrl, type AuthCallbackKind } from './auth';

const url = import.meta.env.VITE_SUPABASE_URL;
const anonKey = import.meta.env.VITE_SUPABASE_ANON_KEY;
export const isDemoMode = import.meta.env.VITE_DEMO_MODE !== 'false' || !url || !anonKey;
const initialAuthCallback = typeof window === 'undefined' ? null : parseAuthCallback(window.location.href);
export const initialAuthCallbackKind = initialAuthCallback?.kind ?? null;

export const supabase: SupabaseClient | null = !isDemoMode && url && anonKey
  ? createClient(url, anonKey, {
      // O SDK processa o retorno de convite/recuperacao antes de expor a sessao.
      // Evita validar manualmente o mesmo par de tokens uma segunda vez.
      auth: { persistSession: true, autoRefreshToken: true, detectSessionInUrl: true },
    })
  : null;

export interface AuthBootstrapResult {
  session: Session | null;
  callbackKind: AuthCallbackKind;
  error: boolean;
}

export async function bootstrapAuthSession(): Promise<AuthBootstrapResult> {
  const client = supabase;
  if (!client) return { session: null, callbackKind: initialAuthCallbackKind, error: false };

  try {
    // getSession aguarda a inicializacao interna do Supabase. Quando a URL contem
    // um retorno de recovery/invite, o SDK ja validou, persistiu e higienizou a
    // sessao antes de esta leitura.
    const result = await client.auth.getSession();
    return {
      session: result.data.session,
      callbackKind: initialAuthCallbackKind,
      error: Boolean(result.error) || Boolean(initialAuthCallback?.errorCode && !result.data.session),
    };
  } finally {
    if (initialAuthCallback?.hasAuthParameters && typeof window !== 'undefined') {
      window.history.replaceState({}, document.title, sanitizeAuthCallbackUrl(window.location.href));
    }
  }
}

